import { useDispatch, useSelector } from "react-redux"
import { ToastContainer, toast } from "react-toastify"
import { bodySelector, setBody, setToastId, setType, toastIdSelector, typeSelector } from "./services/NotificationSlice"
import { useEffect } from "react";
import "react-toastify/dist/ReactToastify.css";

const Notifications = () => {

    const dispatch = useDispatch();
    const body = useSelector(bodySelector);
    const type = useSelector(typeSelector);
    const toastId = useSelector(toastIdSelector);

    useEffect(() => {
        if(type && body){
            switch(type) {
                case 'error':
                    toast.error(body, {
                        autoClose: 2000,
                        hideProgressBar: true,
                        position: toast.POSITION.BOTTOM_RIGHT,
                        toastId: toastId
                    })
                    break;
                case 'info':
                    toast.info(body, {
                        position: toast.POSITION.BOTTOM_RIGHT,
                        isLoading: true,
                        toastId: toastId
                    })
                    break;
                // Stays until it is dismissed. A chip being taken off the
                // board is the one event a player must not miss on a timer.
                case 'sticky':
                    toast.warning(body, {
                        autoClose: false,
                        closeOnClick: true,
                        hideProgressBar: true,
                        position: toast.POSITION.BOTTOM_RIGHT,
                        toastId: toastId
                    })
                    break;
                case 'dismiss':
                    toast.dismiss(toastId);
                    break;
                case 'success':
                    toast.success(body, {
                        autoClose: 2000,
                        position: toast.POSITION.BOTTOM_RIGHT,
                        toastId: toastId
                    })
                    break;
                default:
                    toast.error(body, {
                        autoClose: 2000,
                        hideProgressBar: true,
                        position: toast.POSITION.BOTTOM_RIGHT,
                        toastId: toastId
                    })
            }
            if(body !== ''){
                dispatch(setBody(''));
                dispatch(setType(''));
                dispatch(setToastId(''));
            }
        }

    }, [body, type, toastId, dispatch])

    return(
        <> 
            <ToastContainer />
        </>
    )
}

export default Notifications;